export default __webpack_public_path__ + "static/media/Reader's Belt of the Crescent.d2e6ff73.jpg";